/* WashPair creator reels: videos play muted while on screen (on phones only the one in the middle),
   a tap turns sound on for that video and off for the others, and the cards lean toward the mouse. */
(() => {
  if (window.__wpReels) return; window.__wpReels = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const phone = () => innerWidth <= 760;
  const go = () => document.querySelectorAll('[data-wp-reels]').forEach(sec => {
    const row = sec.querySelector('.wp-reels-row');
    const reels = [...sec.querySelectorAll('.wp-reel')].filter(r => r.querySelector('video')).map(el => ({ el, v: el.querySelector('video'), btn: el.querySelector('.wp-reel-sound'), bar: el.querySelector('.wp-reel-bar i'), seen: false }));
    if (!reels.length) return;
    let inView = false;
    const play = r => { r.v.preload = 'auto'; const p = r.v.play(); if (p && p.catch) p.catch(() => {}); };
    const sync = () => reels.forEach(r => {
      const should = inView && !reduced && (phone() ? r.seen : true);
      if (r.el.classList.contains('is-loud')) {
        if (inView && (!phone() || r.seen)) return;
        r.el.classList.remove('is-loud'); r.v.muted = true; r.btn && r.btn.setAttribute('aria-pressed', 'false');
      }
      if (should) play(r); else if (!r.v.paused) r.v.pause();
    });
    const loud = r => {
      const on = !r.el.classList.contains('is-loud');
      reels.forEach(o => { o.el.classList.remove('is-loud'); o.v.muted = true; o.btn && o.btn.setAttribute('aria-pressed', 'false'); });
      if (on) { r.el.classList.add('is-loud'); r.v.muted = false; r.btn && r.btn.setAttribute('aria-pressed', 'true'); if (r.v.ended || r.v.currentTime > r.v.duration - 0.3) r.v.currentTime = 0; play(r); }
      sync();
    };
    reels.forEach(r => {
      r.btn && r.btn.addEventListener('click', e => { e.stopPropagation(); loud(r); });
      r.v.addEventListener('click', () => loud(r));
      r.v.addEventListener('timeupdate', () => { if (r.bar && r.v.duration) r.bar.style.transform = `scaleX(${(r.v.currentTime / r.v.duration).toFixed(3)})`; });
    });
    new IntersectionObserver(es => es.forEach(e => { inView = e.isIntersecting; sync(); }), { threshold: 0.25 }).observe(row);
    const io = new IntersectionObserver(es => es.forEach(e => { const r = reels.find(x => x.el === e.target); if (r) { r.seen = e.intersectionRatio > 0.6; sync(); } }), { threshold: [0, 0.6, 1] });
    reels.forEach(r => io.observe(r.el));
    if (fine && !reduced) {
      sec.addEventListener('pointermove', e => { const b = sec.getBoundingClientRect(); row.style.setProperty('--tx', ((e.clientX - b.left) / b.width - 0.5).toFixed(3)); row.style.setProperty('--ty', ((e.clientY - b.top) / b.height - 0.5).toFixed(3)); });
      sec.addEventListener('pointerleave', () => { row.style.setProperty('--tx', 0); row.style.setProperty('--ty', 0); });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
